import React from 'react';
import cart from '../assets/images/icons/cart-icon.png';



class Lab_Detail_Listing_Box extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <>
            <div className="lab-detail-listing-col">
                <div className="bg-white-box-shadow lab-content-box">
                    <div className="content-detail">
                        <h3 className="font-16 weight-600">{this.props.testName}</h3>
                        <div className="test-list">
                            <h4 className="font-14 weight-500 text-color-999">Tests Included</h4>
                            <ul className="test-list-row">
                                <li className="test-list">{this.props.testIncludeName}</li>
                                <li className="test-list">Glucose - Random</li>
                                <li className="test-list">HbA1c (Glycosylated Hemoglobin)</li>
                            </ul>
                        </div>
                        <div className="time-box">
                            <h4 className="font-14 weight-500 text-color-999">Processing Time</h4>
                            <p className="font-14">{this.props.testProcessingTime}</p>
                        </div>
                        <div className="content-footer-box">
                            <div className="content-footer-col">
                                <span className="font-16 weight-800">{this.props.testCost}</span>
                            </div>
                            <div className="content-footer-col">
                                <button class="cart-btn">
                                    <img src={cart} alt="" />
                                </button>
                            </div>
                            <div className="content-footer-col">
                                <button class="book-now-btn main-btn font-14">Book Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
};

export default Lab_Detail_Listing_Box;    